// 发现如果只有video，不会使用h264编码视频，而是avc1格式，然后非浏览器播放器不会播放
// 如果同时录制video和audio，会使用h264压缩视频，opus压缩音频。
import * as EBML from 'ts-ebml';
import Media from '../utils/Media';
import codepku from '../utils/codepku';

const browser = codepku.browserType();
const isChrome = browser.type === 'Chrome';
const isFireFox = browser.type === 'Firefox';

export default {
  data() {
    return {
      // recordOption: {
      //   videoBitsPerSecond: 2500000,
      //   mimeType: 'video/mp4',
      // },
      stream: null,
      recorder: null,
      readyFile: null,
      video: null,
      videoRecording: false, // 是否是正在录制中
      videoError: false, // 调用摄像头设备是否报错
      mediaClient: null,
    };
  },
  mounted() {

  },
  beforeDestroy() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  },
  methods: {
    /**
     *
     *
     * @param {*} options {
     * video:
     * audio:
     * }
     */
    initStream(options, stopCb) {
      const client = {}; //用这个去包裹所有的方法，这样一个mixin就能实例化多个
      let chunks = [];
      const previewBox = options.previewBox && document.querySelector(`#${options.previewBox}`);
      const downloadBox = options.downloadBox && document.querySelector(`#${options.downloadBox}`);
      const media = new Media(options);
      // this.mediaClient = media;
      client.media = media;
      return media.start().then(
        (stream) => {
          client.stream = stream;
          if (previewBox) {
            const video = document.createElement('video');
            video.srcObject = stream;
            video.controls = false;
            video.muted = true;
            previewBox.appendChild(video);
            video.play();
            client.video = video;
            this.video = video;
          }
          client.recorder = new MediaRecorder(stream); // 如果两个浏览器同时访问摄像头会报错
          client.recorder.onstop = (e) => {
            client.videoRecording = false; // 已经结束录制
            const dFile = new Blob(chunks, {
              type: 'video/mp4',
            });
            this.getSeekableBlob(dFile, stopCb);
            chunks = []; // 清空以准备下一次录制
            if (downloadBox) {
              this.makeDownload(dFile, downloadBox);
            }
          };
          this.recorder.ondataavailable = (e) => {
            chunks.push(e.data);
          };
          return stream;
        },
      ).catch((err) => {
        this.$message.error('初始化设备失败');
        // return new Promise((resolve, reject) => {
        //   reject(err);
        // });
        return Promise.reject(err);
      });
    },
    startRecord() {
      console.log('%c start record', 'color:red;');
      this.recorder.start();
      this.readyFile = null;
      this.videoRecording = true;
    },
    stopRecord() {
      console.log('%c stop record', 'color:red;');
      this.recorder.stop();
    },
    makeDownload(file, container) {
      const video = document.createElement('video');
      const url = URL.createObjectURL(file);
      video.src = url;
      video.controls = true;
      video.download = `${new Date().valueOf()}.mp4`;
      container.appendChild(video);
    },
    captureImage(video, cb, container) {
      const tmpCanvas = document.createElement('canvas');
      const tracks = this.stream.getVideoTracks();
      const vt = tracks[0];
      const settings = vt.getSettings();
      const {
        aspectRatio,
      } = settings;
      const height = 480;
      tmpCanvas.width = parseInt(height * aspectRatio, 10) || height; // aspectRatio is not supported in firefox
      tmpCanvas.height = height;
      function drawVideo(context) {
        try {
          context.drawImage(video, 0, 0, tmpCanvas.width, tmpCanvas.height);
          tmpCanvas.toBlob((blob) => {
            if (cb && typeof cb === 'function') {
              cb(blob);
            }
          },
          'image/png');
        } catch (e) {
          console.log(e);
          // setTimeout(drawVideo, 1000);
        }
      }
      const context = tmpCanvas.getContext('2d');
      drawVideo(context);
      // context.drawImage(video, 0, 0, tmpCanvas.width, tmpCanvas.height);

      // tmpCanvas.toBlob((blob) => {
      //   console.log(blob);

      //   const url = URL.createObjectURL(blob); // this code donesn't work in firefox
      //   // const fr = new FileReader();
      //   console.log(blob);
      //   // const url = fr.readAsDataURL(blob);
      //   if (cb && typeof cb === 'function') {
      //     cb(blob);
      //   }
      //   const img = document.createElement('img');
      //   img.src = url;
      //   container.appendChild(img);
      // },
      // 'image/png');
    },
    getSeekableBlob(inputBlob, callback) {
      const reader = new EBML.Reader();
      const decoder = new EBML.Decoder();
      const { tools } = EBML;
      const fileReader = new FileReader();
      const that = this;
      fileReader.onload = function (e) {
        const ebmlElms = decoder.decode(this.result);
        ebmlElms.forEach((element) => {
          reader.read(element);
        });
        reader.stop();
        const refineMetadataBuf = tools.makeMetadataSeekable(reader.metadatas, reader.duration, reader.cues);
        const body = this.result.slice(reader.metadataSize);
        const newBlob = new Blob([refineMetadataBuf, body], {
          type: 'video/mp4',
        });
        if (callback && typeof callback === 'function') {
          callback(newBlob);
        }
        that.$emit('record-done', newBlob); // 使用事件订阅模式来获取视频
      };
      fileReader.readAsArrayBuffer(inputBlob);
    },
  },
};

